import React from 'react';
import { Badge, BadgeVariant } from '../shared/Badge';
import EmptyState from '../shared/EmptyState';
import './ExecutiveInsights.css';

export interface Insight {
  category: 'Positive' | 'Risk' | 'Productivity' | 'AI';
  text: string;
}

interface Props {
  insights: Insight[];
  loading: boolean;
}

const CATEGORY_VARIANT: Record<string, BadgeVariant> = {
  Positive: 'success',
  Risk: 'danger',
  Productivity: 'info',
  AI: 'purple',
};

export const ExecutiveInsights: React.FC<Props> = ({ insights, loading }) => (
  <div className="ei-card">
    <div className="ei-header"><h3>Executive Insights</h3></div>
    {loading ? (
      <div className="ei-skeleton" />
    ) : insights.length === 0 ? (
      <EmptyState message="No notable changes this period." compact />
    ) : (
      <ul className="ei-list">
        {insights.map((ins, i) => (
          <li key={i} className="ei-item">
            <Badge variant={CATEGORY_VARIANT[ins.category] || 'neutral'}>{ins.category}</Badge>
            <span className="ei-text">{ins.text}</span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default ExecutiveInsights;
